/*
 * Copyright © Scale Microgrid Solutions Operating, LLC [2023].
 * All rights reserved.
 *
 * SPDX-FileCopyrightText: ©2023 Scale Microgrid Solutions Operating, LLC <legal@scalemicrogrids.com>
 */

import React from "react";
import PropTypes from "prop-types";
import ManageArcadiaIntegrationModal from "./ManageArcadiaIntegrationModal";
import ManagePagerDutyIntegrationModal from "./ManagePagerDutyIntegrationModal";
import ManageUpkeepModal from "./ManageUpkeepModal";

const ManageIntegrationModal = ({
  provider,
  onClose,
  currentSite,
  billConfigs = [],
  siteIntegrations = [],
  pagerDutyServices = [],
  pagerDutyIntegrations = [],
  organizationUuid,
}) => {
  if (provider === "arcadia") {
    return (
      <ManageArcadiaIntegrationModal
        open
        onClose={onClose}
        currentSite={currentSite}
        billConfigs={billConfigs}
        siteIntegrations={siteIntegrations}
      />
    );
  }

  if (provider === "pagerduty") {
    return (
      <ManagePagerDutyIntegrationModal
        open
        onClose={onClose}
        currentSite={currentSite}
        pagerDutyServices={pagerDutyServices}
        pagerDutyIntegrations={pagerDutyIntegrations}
      />
    );
  }

  if (provider === "upkeep") {
    return (
      <ManageUpkeepModal
        open
        onClose={onClose}
        currentSite={currentSite}
        organizationUuid={organizationUuid}
      />
    );
  }

  return null;
};

ManageIntegrationModal.propTypes = {
  provider: PropTypes.oneOf(["arcadia", "pagerduty", "upkeep"]).isRequired,
  onClose: PropTypes.func.isRequired,
  currentSite: PropTypes.object,
  billConfigs: PropTypes.array,
  siteIntegrations: PropTypes.array,
  pagerDutyServices: PropTypes.array,
  pagerDutyIntegrations: PropTypes.array,
  organizationUuid: PropTypes.string,
};

export default ManageIntegrationModal;
